export const ListingAgentIdsEnum = {
    RentListingAgent :{
        formFieldId: 49747
    },
    ListingAgent :{
        formFieldId: 49695
    }
}
